module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row trial-status\">\r\n    <div class=\"row title\">\r\n        Your Free Trial\r\n    </div>\r\n    <div class=\"row content\">\r\n        <div class=\"row days-left\">\r\n            <span id=\"days\">")
    ; __append(escapeFn(RemainingDays))
    ; __append("</span> Days Left\r\n        </div>\r\n        <div class=\"row indicators\">\r\n            <div class=\"remaining-border\">\r\n                ")
    ; 
                var remaining = daysPassed * 100 / trialDays;
                           
            
    ; __append("\r\n                <div class=\"remaining-fill\" id=\"days-fill\" style=\"width:")
    ; __append(escapeFn(remaining))
    ; __append("%;\"></div>\r\n              </div>\r\n        </div>\r\n        <div class=\"row apps-used\">\r\n            <span id=\"apps\">")
    ; __append(escapeFn(UsedForms))
    ; __append("/")
    ; __append(escapeFn(MaxForms))
    ; __append("</span> Apps Used\r\n        </div>\r\n        ")
    ;  if(MaxForms <= 20){ 
    ; __append("\r\n        <div class=\"row indicators\">\r\n\r\n            ")
    ; 
                var width = 197 - 20; //20 to account for the scroll bar in case it appears
                var indicatorWidth = width / MaxForms;
                var countUsed = 0;
             
                for(var i = 0; i < MaxForms; i++) {

                    if(countUsed < UsedForms){
            
    ; __append("\r\n            <div class=\"indicator used\" style=\"min-width:")
    ; __append(escapeFn(indicatorWidth-5 ))
    ; __append("px;\"></div>\r\n\r\n            ")
    ; 
                    }

                    else{
            
    ; __append("\r\n            <div class=\"indicator notUsed\" style=\"min-width:")
    ; __append(escapeFn(indicatorWidth-5 ))
    ; __append("px;\"></div>\r\n            ")
    ; 
                    }

                    countUsed ++;
                 }
            
    ; __append("\r\n           \r\n        </div>\r\n        ")
    ;  } 
    ; __append("\r\n        <div class=\"row apps-used\">\r\n            <span id=\"rpt\">")
    ; __append(escapeFn(UsedReports))
    ; __append("/")
    ; __append(escapeFn(MaxReports))
    ; __append("</span> Reports Used\r\n        </div>\r\n        ")
    ;  if(MaxReports <= 20){ 
    ; __append("\r\n        <div class=\"row indicators\">\r\n\r\n            ")
    ; 
                var indicatorWidth = width / MaxReports;
                var countUsed = 0;
             
                for(var i = 0; i < MaxReports; i++) {

                    if(countUsed < UsedReports){
            
    ; __append("\r\n            <div class=\"indicator used\" style=\"min-width:")
    ; __append(escapeFn(indicatorWidth-5 ))
    ; __append("px;\"></div>\r\n\r\n            ")
    ; 
                    }

                    else{
            
    ; __append("\r\n            <div class=\"indicator notUsed\" style=\"min-width:")
    ; __append(escapeFn(indicatorWidth-5 ))
    ; __append("px;\"></div>\r\n            ")
    ; 
                    }

                    countUsed ++;
                 }
            
    ; __append("\r\n           \r\n        </div>\r\n        ")
    ;  } 
    ; __append("\r\n        <div class=\"row button\" align=\"center\">\r\n            <button id=\"getQuote\" style=\"width:90%;margin-top: 10px;\">Get a Quote</button>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}